var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02"},[_c('router-view',{attrs:{"toolId":_vm.toolId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }